import { HotToastService } from "@ngneat/hot-toast";
import { AccountantService } from "./../../../main/accountant/accountant.service";
import { Component, Input, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgClass } from "@angular/common";

@Component({
    selector: "app-invite-message",
    templateUrl: "./invite-message.component.html",
    styleUrls: [
        "./invite-message.component.scss",
        "../../../main/accountant/tracked-items-dashboard.component.css",
        "../../../files-manager/files-manager.component.scss",
        "../../templates.component.scss",
    ],
    imports: [NgClass, FormsModule]
})
export class InviteMessageComponent implements OnInit {
  @Input() defaultEmail: string = "";
  isLoading: boolean = true;

  constructor(
    private accountantService: AccountantService,
    private toastr: HotToastService
  ) {}

  ngOnInit(): void {
    this.getDefaultEmailInvite();
  }

  getDefaultEmailInvite() {
    this.accountantService
      .getDefaultInviteEmail()
      .then(({ default_email }: any) => {
        // default_email = default_email.replace(/<br>/g, "\n");
        this.defaultEmail = default_email;
        // this.isLoading = false;
      });
  }

  changeDefaultInviteEmail() {
    // const formatedEmail = this.defaultEmail.replace(/\n/g, "<br>");
    this.accountantService
      .changeDefaultInviteEmail(this.defaultEmail)
      .then(({ message }: any) => {
        this.toastr.success("Default email updated successfully!");
      });
  }
}
